/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SidebarFilter from './SidebarFilter';
import DefaultFilter from './DefaultFilter';

export default function FilterMain(props) {
	const {
		modalVisible,
		setModalVisibility,
		updateProducts,
		searchComponents
	} = props;
	const filterProps = {
		...props,
		callback: updateProducts,
		mobileModalVisible: modalVisible,
		setMobileModalVisibility: setModalVisibility,
		showTriggerButton: true,
	};
	const { layout } = searchComponents || {};

	if (!layout) return <DefaultFilter {...filterProps} />;
	switch (layout) {
	case 'none':
		return null;
	case 'sidebar':
		return <SidebarFilter {...filterProps} />;
	default:
		return <DefaultFilter {...filterProps} />;
	}
}
